import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, RootState } from '../../../store';

const GreetingBar: React.FC = () => {
  const { t } = useTranslation();

  const userInfo = useAppSelector((state: RootState) => state.user.userInfo);
  const firstName = userInfo?.first_name || userInfo?.name?.split(' ')[0] || 'there';

  const greeting = useMemo(() => {
    const hour = new Date().getHours();
    if (hour < 12) return t('Good morning');
    if (hour < 17) return t('Good afternoon');
    return t('Good evening');
  }, [t]);

  const dateStr = useMemo(() => {
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }).format(new Date());
  }, []);

  return (
    <div className="h-full bg-white dark:bg-gray-800 rounded-xl border border-gray-200/80 dark:border-gray-700/80 p-5 flex flex-col justify-center">
      <h1 className="text-2xl text-gray-900 dark:text-gray-50">
        {greeting}, {firstName}
      </h1>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{dateStr}</p>
    </div>
  );
};

export default GreetingBar;
